<template>
    <main>
        <section class="vx-row justify-center">
            <div class="vx-col w-full md:w-2/3 lg:w-3/4">
                <vx-card class="px-4">
                    <div class="mb-4">
                        <router-link class="flex items-center" to="/profile">
                            <feather-icon icon="ChevronLeftIcon"></feather-icon>
                            <strong class="block">Kembali</strong>
                        </router-link>
                    </div>
                    <header class="flex flex-col justify-center mb-4">
                        <h1 id="headline" class="text-3xl md:text-4xl lg:text-5xl text-center" >
                            <strong class="text-primary">Tracking</strong>
                            <strong class="text-warning"> Qurban</strong>
                        </h1>
                    </header>
                    <section class="text-center mb-6">
                        <h6 class="text-grey">Masukan kode qurban yang telah dikirimkan ke email anda</h6>
                    </section>
                    <section class="input-container mb-8">
                        <input
                            id="kode-input"
                            class="w-full rounded-full pl-4 border-2 py-3 border-grey"
                            style="border-color: #ddd !important;"
                            v-model="kode"
                        />
                    </section>
                    <section>
                        <button
                            id="submit"
                            class="w-full rounded-full pl-4 border-2 py-3 border-none bg-primary"
                            style="border-color: #ddd !important;"
                            @click.prevent="track"
                            :disabled="isNotValid"
                        >
                        <strong class="text-warning tracking-tight">LACAK</strong>
                        </button>
                    </section>
                </vx-card>
            </div>
        </section>
    </main>
</template>
<script>
    export default {
        data: () => ({
            kode: null
        }),
        computed: {
            isNotValid() {
                return this.kode == null || this.kode == '';
            }
        },
        methods: {
            track() {
                if(
                    this.kode == null || 
                    this.kode == ''
                ) {
                    this.$vs.notify({
                        title: 'Oops',
                        text: 'Harap isi kode qurban',
                        color: 'warning',
                        position: 'top-right'
                    });

                    return false;
                }

                this.$store.dispatch('qurban/setTrackingCode', this.kode.trim());
                this.$router.push(`/track-qurban/result`);
            }
        },
        created() {
            this.$store.dispatch('qurban/removeTrackingCode');
        }
    };
</script>
<style>
#kode-input input, #submit {
    border-radius: 50%;
}
#submit {
    font-family: inherit;
}
#submit:disabled {
    background-color: #ddd !important;
}
</style>